import React, { Component } from 'react';
import DashboardPage from './DashboardPage';
import { connect } from 'react-redux';
import { dashboardActions } from '../../../actions/dashboard.action';
import { configureActions } from '../../../actions/configure.action';
import { bindActionCreators } from 'redux';
import Backend from '../../Layouts/Backend';
import Loading from '../../Helpers/Loading';
import helper from '../../../utils/helper';
import qs from 'qs';
import moment from 'moment';

function getCurrentTime() {
  return moment().format('MM/DD/yyyy HH:mm:ss');
}

export class DashboardWeb extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alarmList: [],
      availableGroups: [],
      sensors: [],
      loading: false,
      isFetching: false,
      errors: '',
      intervalId: null,
      groupId: null,
      lastUpdated: getCurrentTime(),
    };
    this.refreshRate = helper.getSetting('ValueRefreshRateSec');
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    let state = {};
    if (nextProps.dashboard.alarmList !== prevState.alarmList) {
      state.alarmList = nextProps.dashboard.alarmList;
    }
    if (nextProps.dashboard.availableGroups !== prevState.availableGroups) {
      state.availableGroups = nextProps.dashboard.availableGroups;
    }
    // if (nextProps.configure.sensors !== prevState.sensors) {
    //   state.sensors = nextProps.configure.sensors;
    // }
    if (nextProps.dashboard.loading !== prevState.loading) {
      state.loading = nextProps.dashboard.loading;
    }
    state.errors = helper.centralizeError([
      nextProps.dashboard.errors,
      nextProps.configure.errors,
    ]);
    return Object.keys(state).length ? state : null;
  }

  fetchData() {
    const intervalId = setInterval(async () => {
      console.log('fetch data')
      //await this.props.dashboardActions.getAlarmList();
      await this.props.dashboardActions.getAvailableGroups();
      this.setState({ lastUpdated: getCurrentTime() });
    }, parseInt(this.refreshRate.value) * 1000);
    this.setState({ intervalId });
  }

  getCMVData(groupId) {
    this.props.configureActions
      .getSensorsMVByGroup(groupId)
      .then((resp) => this.setState({ sensors: resp }));
  }

  fetchALandCMVdata(groupId) {
    const intervalId = setInterval(async () => {
      console.log('fetchALandCMVdata')
      await this.props.dashboardActions.getAlarmList();
      await this.props.dashboardActions.getAvailableGroups();
      await this.props.dashboardActions.getAvailableGroupsSummaries(groupId);
      // await this.props.configureActions.getSensorsMVByGroup(groupId);
      this.getCMVData(groupId);
      this.setState({ lastUpdated: getCurrentTime() });
    }, parseInt(this.refreshRate.value) * 1000);
    this.setState({ intervalId });
  }

  stopFetchingData() {
    if (this.state.intervalId) {
      clearInterval(this.state.intervalId);
      this.setState({ intervalId: null });
    }
  }

  async componentDidMount() {
    const { search } = this.props.location;
    if (search) {
      const { groupId } = qs.parse(this.props.location.search, {
        ignoreQueryPrefix: true,
      });
      this.setState({ isFetching: true }, async () => {
        await this.props.dashboardActions.getAlarmList();
        await this.props.dashboardActions.getAvailableGroups();
        await this.props.dashboardActions.getAvailableGroupsSummaries(groupId);
        // await this.props.configureActions.getSensorsMVByGroup(groupId);
        this.getCMVData(groupId);
        this.setState(
          { isFetching: false, lastUpdated: getCurrentTime() },
          () => this.fetchALandCMVdata(groupId),
        );
      });
    } else {
      this.setState({ isFetching: true }, async () => {
        await this.props.dashboardActions.getAlarmList();
        await this.props.dashboardActions.getAvailableGroups().then((resp) => {
          if (resp.length === 1) {
            const group = resp[0];
            this.props.history.push(`/?groupId=${group.groupId}`);
          }
        });
        this.setState(
          { isFetching: false, lastUpdated: getCurrentTime() },
          () => this.fetchData(),
        );
      });
    }
  }

  async componentDidUpdate(prevProps) {
    const { search } = this.props.location;
    if (search) {
      if (prevProps.location.search !== search) {
        const { groupId } = qs.parse(this.props.location.search, {
          ignoreQueryPrefix: true,
        });
        this.setState({ sensors: [] });
        await this.props.dashboardActions.getAvailableGroupsSummaries(groupId);
        // await this.props.configureActions.getSensorsMVByGroup(groupId);
        this.getCMVData(groupId);
        this.setState({ lastUpdated: getCurrentTime() });
        this.stopFetchingData();
        this.fetchALandCMVdata(groupId);
      }
    } else {
      if (prevProps.location.search !== search) {
        this.stopFetchingData();
        this.fetchData();
      }
    }
  }

  componentWillUnmount() {
    this.stopFetchingData();
  }

  shouldFetchData = (isSelected) => {
    if (isSelected) {
      this.stopFetchingData();
    } else {
      if (!this.state.intervalId) {
        this.fetchData();
      }
    }
  };

  onBack = () => {
    this.stopFetchingData();
    this.props.history.goBack();
  };

  onAtRest = async (groupIds) => {
    await this.props.configureActions
      .atRest(groupIds)
      .then(async () => await this.props.dashboardActions.getAvailableGroups());
  };
  onInOperation = (groupIds) => {
    this.props.configureActions
      .inOperation(groupIds)
      .then(async () => await this.props.dashboardActions.getAvailableGroups());
  };
  onDisableSensor = async (params, type) => {
    await this.props.configureActions
      .disableSensor(params, type)
      .then(async () => {
        if (type === 'group') {
          await this.props.dashboardActions.getAvailableGroups();
        } else {
          const { groupId } = qs.parse(this.props.location.search, {
            ignoreQueryPrefix: true,
          });
          // await this.props.configureActions.getSensorsMVByGroup(groupId);
          this.getCMVData(groupId);
        }
      });
  };

  onEnableSensor = async (selectedGroups, type) => {
    await this.props.configureActions
      .enableSensor(selectedGroups, type)
      .then(async () => {
        if (type === 'group') {
          await this.props.dashboardActions.getAvailableGroups();
        } else {
          const { groupId } = qs.parse(this.props.location.search, {
            ignoreQueryPrefix: true,
          });
          // await this.props.configureActions.getSensorsMVByGroup(groupId);
          this.getCMVData(groupId);
        }
      });
  };

  render() {
    if (this.state.isFetching) {
      return (
        <Backend>
          <Loading />
        </Backend>
      );
    }
    return (
      <DashboardPage
        {...this.state}
        shouldFetchData={this.shouldFetchData}
        onAtRest={this.onAtRest}
        onInOperation={this.onInOperation}
        onDisableSensor={this.onDisableSensor}
        onEnableSensor={this.onEnableSensor}
        onBack={this.onBack}
        groupId={
          qs.parse(this.props.location.search, {
            ignoreQueryPrefix: true,
          }).groupId
        }
        isMobile={this.props.isMobile}
        setIsMobile={this.props.setIsMobile}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    dashboard: state.dashboard,
    configure: state.configure,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    configureActions: bindActionCreators(
      Object.assign({}, configureActions),
      dispatch,
    ),
    dashboardActions: bindActionCreators(
      Object.assign({}, dashboardActions),
      dispatch,
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DashboardWeb);
